"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  padding: ", ";\n  box-shadow: ", ";\n  width: 100%;\n  min-height: 40vh;\n  margin: 20vh 0 ", " 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n  min-height: 100vh;\n  padding: 16px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPage = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Block_1 = require("./Block");

var Typography_1 = require("./Typography");

var Container = styled_components_1["default"].div(_templateObject());
var Page = styled_components_1["default"].div(_templateObject2(), function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@shadow-large'];
}, function (props) {
  return props.theme['@size-xxl'];
});

var ErrorPage = function ErrorPage(_ref) {
  var title = _ref.title,
      technical = _ref.technical,
      description = _ref.description,
      action = _ref.action,
      onActionClick = _ref.onActionClick;
  return react_1["default"].createElement(Container, null, react_1["default"].createElement(Page, null, react_1["default"].createElement(Typography_1.H1, {
    isBlock: false
  }, title), react_1["default"].createElement(Typography_1.H1Subtitle, null, technical), react_1["default"].createElement(Block_1.Block, {
    marginTop: '@size-l'
  }, react_1["default"].createElement(Typography_1.BodyLarge, {
    isBlock: true
  }, description), action && onActionClick ? react_1["default"].createElement(antd_1.Button, {
    type: 'primary',
    onClick: onActionClick,
    children: action
  }) : null)));
};

exports.ErrorPage = ErrorPage;